import * as React from "react";
const SvgClose = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.163 3.163a.556.556 0 0 1 .785 0L8 7.214l4.052-4.051a.556.556 0 0 1 .785.785L8.786 8l4.051 4.052a.556.556 0 0 1-.785.785L8 8.786l-4.052 4.051a.556.556 0 0 1-.785-.785L7.214 8 3.163 3.948a.556.556 0 0 1 0-.785",
    clipRule: "evenodd"
  }
));
export default SvgClose;
